import { Content as RadixTabsContent } from '@radix-ui/react-tabs';
import type { TabsContentProps as RadixTabsContentProps } from '@radix-ui/react-tabs';
import type { JSX } from 'react';

export type TabsContentProps = Pick<RadixTabsContentProps, 'children' | 'value'>;

export const TabsContent = ({ children, value }: TabsContentProps): JSX.Element => {
  return <RadixTabsContent value={value}>{children}</RadixTabsContent>;
};

TabsContent.displayName = 'TabsContent';
